import {
  ManageSearch as MessageSearchIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { telegramUsersApi } from 'api';
import { useMutation } from 'hooks';
import { TranslationNamespace } from 'i18n';

type Props = {
  userId: string;
  chatId: number;
  isAuthenticated: boolean;
};

export const CheckTelegramChatMembershipIcon: React.FC<Props> = ({
  userId,
  chatId,
  isAuthenticated,
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.telegram_flow.telegram_users',
  });

  const { mutate: checkChatMembership, isLoading } = useMutation(
    telegramUsersApi.checkChatMembership,
    {
      notifierType: 'execute',
      notifierMessages: {
        loading: t('check_chat.loading'),
        success: (data: { isInChat: boolean }) => {
          if (data.isInChat) {
            return t('check_chat.success_in_chat');
          } else {
            throw new Error(t('check_chat.error_not_in_chat'));
          }
        },
        error: (error: any) => {
          if (error.message === t('check_chat.error_not_in_chat')) {
            return error.message;
          }
          return t('check_chat.error');
        },
      },
    },
  );

  const handleClick = useCallback(() => {
    checkChatMembership({ userId, chatId: chatId! });
  }, [chatId, userId, checkChatMembership]);

  if (!chatId || !userId) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Tooltip title={t('tooltip.check_chat_membership_not_authenticated')}>
        <WarningAmberIcon fontSize="small" color="warning" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('tooltip.check_chat_membership')}>
      <IconButton size="small" onClick={handleClick} disabled={isLoading}>
        <MessageSearchIcon />
      </IconButton>
    </Tooltip>
  );
};
